import React, { useCallback, useState } from "react";
import { Form, Formik, FormikConfig, FormikProps } from "formik";
import { useNavigate } from "react-router-dom";
import { FormikHelpers } from "formik/dist/types";
import FormButtons from "./FormButtons";
import useTrackPromise from "../../hooks/useTrackPromise";
import { PromiseStatus } from "../../../core/PromiseStatus";

const FormikWrapper: React.FC<FormikWrapperProps> = (props) => {
    const navigate = useNavigate();
    const [onSubmit, , onSubmitStatus] = useTrackPromise(props.onSubmit);
    const [onSuccess, setOnSuccess] = useState<() => void>();
    const [redirect, setRedirect] = useState<string>();

    const buttons = useCallback((formik: FormikProps<any>) => {
        let buttons = props.buttons;

        if (typeof buttons === 'function') {
            buttons = buttons(formik);
        }

        return buttons;
    }, [])

    return (
        <Formik
            validateOnChange={ false }
            validateOnBlur={ false }
            { ...props }
            onSubmit={ (values, helpers) => {
                onSubmit(values, helpers)
                    .then(result => {
                        props.onSubmissionSuccess && props.onSubmissionSuccess();
                        props.redirectOnSuccess && navigate(props.redirectOnSuccess);
                        onSuccess && onSuccess();
                        redirect && navigate(redirect);
                        return result;
                    })
            } }
        >
            { (formik) => {
                return (
                    <Form style={ { width: '100%' } } noValidate>
                        { props.children!(formik, onSubmitStatus) }
                        {
                            props.buttons !== null &&
                            <FormButtons
                                formIsDirty={ formik.dirty }
                                formStatus={ onSubmitStatus }
                                formHasErrors={ !formik.isValid }
                                disabled={ props.buttonsDisabled }
                                noSticky={ props.noStickyButtons }
                                buttons={ buttons(formik)?.map(button => ({
                                    ...button,
                                    onClick: () => {
                                        button.onClick && button.onClick(formik);
                                        setOnSuccess(button.onSuccess);
                                        setRedirect(button.redirect);
                                    }
                                })) }
                            />
                        }
                    </Form>
                );

            } }
        </Formik>

    );
}
export default FormikWrapper;

// @ts-ignore
interface FormikWrapperProps<T = any> extends FormikConfig<T> {
    readonly children: ((props: FormikProps<T>, status: PromiseStatus) => React.ReactNode);
    readonly onSubmissionSuccess?: () => void;
    readonly redirectOnSuccess?: string;
    readonly onSubmit: (values: T, formikHelpers: FormikHelpers<T>) => Promise<any>;
    readonly buttonsDisabled?: boolean;
    readonly buttons?: Array<FormButtonProps> | ((formik: FormikProps<T>) => FormButtonProps[]) | null;
    readonly noStickyButtons?: boolean;
}

export interface FormButtonProps {
    readonly text: string;
    readonly onSuccess?: () => void;
    readonly onClick?: (formik: FormikProps<any>) => void;
    readonly redirect?: string;
    readonly variant?: 'submit' | 'other';
    readonly type?: 'submit' | 'button' | 'reset';
    readonly disabled?: boolean;
}